import {inject, Pipe, PipeTransform} from '@angular/core';
import {ValidationErrors} from '@angular/forms';
import {DEFAULT_VALIDATION_MESSAGES, VALIDATION_MESSAGES_TOKEN,} from '../tokens/validation-messages.token';

/**
 * Pipe pura che trasforma un oggetto `ValidationErrors` di Angular
 * nel primo messaggio di errore leggibile (in italiano).
 *
 * Priorità: messaggi custom (VALIDATION_MESSAGES_TOKEN) > messaggi di default.
 *
 * Utilizzo nel template:
 * ```html
 * <span class="field-error">{{ control.errors | validationMessage }}</span>
 * ```
 */
@Pipe({
  name: 'validationMessage',
  standalone: true,
  pure: true,
})
export class ValidationMessagePipe implements PipeTransform {
  private readonly customMessages = inject(VALIDATION_MESSAGES_TOKEN);

  transform(errors: ValidationErrors | null | undefined): string {
    if (!errors) return '';

    const firstKey = Object.keys(errors)[0];
    const errorData = errors[firstKey];

    // 1. Se il validatore ha già inviato un messaggio testuale direttamente nell'errore
    // (es. { mioErrore: "Messaggio diretto" })
    if (typeof errorData === 'string') return errorData;

    // 2. Altrimenti usa la mappa dei messaggi (custom o default)
    const fn =
      this.customMessages[firstKey] ??
      DEFAULT_VALIDATION_MESSAGES[firstKey];

    return fn ? fn(errorData) : 'Campo non valido';
  }
}
